import * as z from "zod";
import { laneOutput } from "./lane";

const countryCode = z.string().length(2);

export const updateLanes = {
  name: "updateLanes" as const,
  input: z.object({
    pairs: z
      .array(
        z.object({
          originCountry: countryCode,
          destinationCountry: countryCode,
        }),
      )
      .max(500),
  }),
  output: z.object({ lanes: z.array(laneOutput) }),
};
